const vt = {
    STRING: "string",
    NUMBER: "number",
    BOOLEAN: "boolean",
    DATE: "date",
    DATETIME: "datetime",
    TIME: "time",
    ENUM: "enum",
    ARRAY: "array",
    ARRAY_NUMBER: "array_number",
    ARRAY_STRING: "array_string",
    ARRAY_DATE: "array_date",
    ARRAY_OBJECT: "array_objectId",
    ARRAY_BOOLEAN: "array_boolean",
    OBJECT: "object",
    MIXED: "mixed",
};
const contexts = {
    CONTACT: "contact",
    CONVERSATION: "conversation",
    BLOCK: "block",
    EVENT: "event",
    WEBHOOK: "webhook",
    SYSTEM: "system",
    CUSTOM: "custom",
};
const defaultOperators = {
    string: [
        "equal",
        "not_equal",
        "contains",
        "not_contains",
        "empty",
        "not_empty",
        "starts_with",
        "ends_with",
        "shorter_than",
        "longer_than",
    ],
    array: ["equal", "not_equal", "contains", "not_contains", "empty", "not_empty"],
    number: ["equal", "not_equal", "greater_than", "less_than", "greater_than_or_equal", "less_than_or_equal"],
    boolean: ["equal", "not_equal", "empty", "not_empty"],
    date: [
        "equal",
        "not_equal",
        "greater_than",
        "less_than",
        "greater_than_or_equal",
        "less_than_or_equal",
        "empty",
        "not_empty",
    ],
    ObjectId: ["equal", "not_equal", "empty", "not_empty"],
    object: ["equal", "not_equal", "empty", "not_empty"],
    mixed: [
        "equal",
        "not_equal",
        "contains",
        "not_contains",
        "empty",
        "not_empty",
        "starts_with",
        "ends_with",
        "shorter_than",
        "longer_than",
        "greater_than",
        "less_than",
        "greater_than_or_equal",
        "less_than_or_equal",
    ],
};

const ga = (
    context,
    value,
    label,
    valueType = "string",
    controlType = "input",
    subAttributes = [],
    defaultFilterValue = undefined,
    defaultOperator = undefined,
    availableOperators = undefined,
    options = undefined
) => {
    return {
        context,
        name,
        value,
        label,
        defaultOperator: defaultOperator || "equal",
        defaultFilterValue,
        availableOperators: availableOperators || defaultOperators[valueType] || ["equal", "not_equal"],
        controlType,
        options,
        subAttributes,
        valueType,
    };
};

const AutomationCommon = {
    ga,
    vt,
    contexts,
    defaultOperators,
};

export default AutomationCommon;
